export default __webpack_public_path__ + "static/media/room-3Bed-double_compressed.8844f1b3.mp4";